import axios from 'axios'

const dataService = {
  getSiteText () {
    return new Promise((resolve) => {
      axios.get('https://strapi.arlingtonva.us/camp-listing-site-texts?slug=camp-listing-site-text')
      // axios.get('https://stg-strapi.arlingtonva.us/camp-listing-site-texts?slug=test')
        .then(response => {
          var data = response.data
          resolve(data)
        })
    })
  },

  getCamps () {
    return new Promise((resolve) => {
      axios.get('https://s3.amazonaws.com/camps.arlingtonva.us/static/camps.json')
        .then(response => {
          console.log(response.data)
          var data = response.data
          data.forEach(element => {
            var dateRange = element['Date Range']
            if (dateRange) {
              var startMonth = parseInt(dateRange.substring(0, dateRange.indexOf('/'))) - 1
              var startDay = parseInt(dateRange.substring(dateRange.indexOf('/') + 1, dateRange.indexOf('-')))
              element.startDate = new Date(2018, startMonth, startDay)
            } else {
              element.startDate = null
            }
          })
          resolve(data)
        })
    })
  },

  getCampListing () {
    return new Promise(resolve => {
      axios.get('https://datahub-v2.arlingtonva.us/api/recreation/vw_camp_section_with_enrollment?$top=10000').then(
        response => {
          let data = response.data
          data.forEach(attribute => {
            attribute['Camp Description'] = attribute['campDesc']
            attribute['Camp Type'] = attribute['campTypeName']
            attribute['Category'] = attribute['campCategoryName']
            attribute['Age Range'] = attribute['ageRangeCode']
            attribute['Core Camp Time'] = attribute['coreCampTimeCode']
            attribute['Core Fee'] = attribute['coreFeeAmt']
            attribute['Extended Hours'] = attribute['extendedHoursCode']
            attribute['Location'] = attribute['locationDesc']
            attribute['Official Title'] = attribute['campTitleName']
            attribute['Program Status'] = attribute['programStatusCode']
            attribute['Registration Website'] = attribute['registrationWebsiteText']
            attribute['Date Range'] = new Date(attribute['sectionStartDate']).toLocaleDateString('en-US', {timeZone: 'UTC'}) + ' - ' + new Date(attribute['sectionEndDate']).toLocaleDateString('en-US', {timeZone: 'UTC'})
            attribute['startDate'] = attribute['sectionStartDate']

            delete attribute['campDesc']
            delete attribute['campTypeName']
            delete attribute['campCategoryName']
            delete attribute['ageRangeCode']
            delete attribute['coreCampTimeCode']
            delete attribute['coreFeeAmt']
            delete attribute['extendedHoursCode']
            delete attribute['locationDesc']
            delete attribute['campTitleName']
            delete attribute['programStatusCode']
            delete attribute['registrationWebsiteText']
            delete attribute['sectionStartDate']
          })
          let today = new Date()
          data = data.filter(a => {
            let endDateString = new Date(a.sectionEndDate).toLocaleDateString('en-US', {timeZone: 'UTC'})
            let endDate = new Date(endDateString)
            return endDate >= today
          })
          resolve(data)
        }
      )
    })
  }
}

export default dataService



// WEBPACK FOOTER //
// ./src/components/data.service.js